var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transfer_icon",
    "data-name": "Transfer icon",
    transform: "translate(32) rotate(90)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(2.11 28.872) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1.333,12.321A1.333,1.333,0,0,1,.39,10.045L7.759,2.676l-5.966.009h0a1.333,1.333,0,0,1,0-2.667L14.206,0,2.276,11.93A1.329,1.329,0,0,1,1.333,12.321Z",
    transform: "translate(11.377 0) rotate(45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1.333,12.321a1.333,1.333,0,0,1-.943-2.276L7.759,2.676l-5.966.009a1.333,1.333,0,0,1,0-2.667L14.206,0,2.276,11.93A1.329,1.329,0,0,1,1.333,12.321Z",
    transform: "translate(14.045 28.09) rotate(-135)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M2.67,6.52H0V4A4.01,4.01,0,0,1,4.014,0H5.537V2.67H4.014A1.337,1.337,0,0,0,2.67,4V6.52Z",
    transform: "translate(0 7.373)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M2.67,6.52H0V4A4.01,4.01,0,0,1,4.014,0H5.537V2.67H4.014A1.337,1.337,0,0,0,2.67,4V6.52Z",
    transform: "translate(25.536 20.719) rotate(180)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591-2",
    "data-name": "Path 1591",
    d: "M1.333,1.333V2.667l0-1.333h0M1.333,0A1.333,1.333,0,0,1,2.667,1.333V2.667A1.333,1.333,0,0,1,0,2.667V1.333A1.333,1.333,0,0,1,1.333,0Z",
    transform: "translate(0 11.223)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591-3",
    "data-name": "Path 1591",
    d: "M1.333,1.333V2.667l0-1.333h0M1.333,0A1.333,1.333,0,0,1,2.667,1.333V2.667A1.333,1.333,0,0,1,0,2.667V1.333A1.333,1.333,0,0,1,1.333,0Z",
    transform: "translate(25.536 16.876) rotate(180)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.7a30a9c1.svg";
export { ForwardRef as ReactComponent };